module.exports = __webpack_public_path__ + "img/52114146_L.f6f802ef.png";